import { baseApi, baseFormDataApi } from '@/config/axios';

import {
  FetchCarOrderParams,
  FetchCarOrderResponse,
  FetchTransportResponse,
  UpdateCarParams,
  UpdateCarResponse,
  UploadCarPhotoResponse,
} from '@/types/api/carApi';
import { CarAssetValueResponse } from '@/types/api/carAssetValueApi';
import { RecommendedCarResponse } from '@/types/api/recommendedCarApi';
import { RecommendedCarCatalogResponse } from '@/types/api/recommendedCarCatalogApi';
import { CancelReasonResponse } from '@/types/api/warrantyApi';

//霆贋ｸ｡諠・ｱ
export const updateCarApi = (
  t_stock_car_id: string,
  params: UpdateCarParams,
): Promise<UpdateCarResponse> =>
  baseApi.post(`/v1/customer/cars/${t_stock_car_id}`, params);

export const fetchTransportApi = (): Promise<FetchTransportResponse> =>
  baseApi.get('v1/code-map/transport_bu');

export const fetchWarrantyCancelReasonApi = (): Promise<CancelReasonResponse> =>
  baseApi.get('v1/code-map/cancel_reason');

export const postUploadCarPhoto = (
  m_customer_id: number,
  t_stock_car_id: number,
  upload_file: string | Blob | File,
) => {
  const formData = new FormData();
  formData.append('m_customer_id', String(m_customer_id));
  formData.append('t_stock_car_id', String(t_stock_car_id));
  formData.append('upload_file', upload_file);

  return baseFormDataApi.post<UploadCarPhotoResponse>(
    'v1/customer/car_image_upload',
    formData,
  );
};

export const fetchCarOrderApi = (
  params: FetchCarOrderParams,
): Promise<FetchCarOrderResponse> =>
  baseApi.get('v1/customer/purchase-order', { params });

export const fetchCarAssetValueApi = (
  tStockCarId: number,
  params?: { mlg?: number; ex_col_id?: string },
): Promise<CarAssetValueResponse> =>
  baseApi.get(`v1/customer/cars/${tStockCarId}/asset-value`, { params });

export const fetchAssetValueColorsApi = (): Promise<{
  data: { success: boolean; data: { id: number; color_name: string }[] };
}> => baseApi.get('v1/customer/asset-value/colors');

export const fetchRecommendedCarsApi = (
  tStockCarId: number,
): Promise<RecommendedCarResponse> =>
  baseApi.get(`v1/customer/cars/${tStockCarId}/recommended-cars`);

export const fetchRecommendedCarCatalogApi = (
  mkCd: string,
  carnmCd: string,
): Promise<RecommendedCarCatalogResponse> =>
  baseApi.get(`v1/customer/recommended-cars/catalog/${mkCd}/${carnmCd}`);

